import { palette } from '@livable/saas-react-components';
import { makeStyles } from '@mui/styles';
const useMoveOutStyles = makeStyles({
  disabled: {
    opacity: 0.5
  },
  footer: {
    margin: '40px -40px -32px -40px'
  },
  fseBlock: {
    background: 'white',
    border: "1px solid ".concat(palette.shades[300]),
    borderRadius: '2px',
    display: 'flex',
    flexDirection: 'row',
    marginTop: '24px',
    padding: '25px',
    position: 'relative'
  },
  fseBlockLeftPart: {
    display: 'flex',
    flexDirection: 'row'
  },
  fseBlockText: {
    marginLeft: '15px'
  },
  fseBlockButton: {
    position: 'absolute',
    right: '20px',
    top: '60px'
  },
  fseBlockChip: {
    borderRadius: '2px',
    padding: '2px 6px',
    position: 'absolute',
    right: '20px'
  },
  fseBlockButtonText: {
    marginLeft: '5px'
  },
  datePicker: {
    '&.disabled': {
      position: 'relative',
      '&:after': {
        left: '0',
        right: '0',
        bottom: '0',
        zIndex: '1',
        top: '-10px',
        content: '""',
        display: 'block',
        position: 'absolute'
      }
    }
  },
  infoBlock: {
    '& .MuiChip-root': {
      width: '100%',
      padding: '8px',
      '& svg': {
        marginRight: '4px'
      }
    }
  }
});
export default useMoveOutStyles;